var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'loading-container': true, loading: _vm.isLoading, visible: _vm.isVisible}},[_c('div',{staticClass:"loader",style:({ width: _vm.progress + '%' })},[_c('div',{staticClass:"light"})]),_c('div',{staticClass:"glow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }